import { render, staticRenderFns } from "./ReferenceCell.vue?vue&type=template&id=4f2d6b06&scoped=true&"
import script from "./ReferenceCell.vue?vue&type=script&lang=js&"
export * from "./ReferenceCell.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCell.vue?vue&type=style&index=0&id=4f2d6b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d6b06",
  null
  
)

export default component.exports